import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CalendarClearStateUnguard } from 'app/core/guards/calendar-clear-state.unguard';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { GetOrderTemplatesGuard } from 'app/core/store/template/order-templates.resolve';
import { GetRelocationTemplatesGuard } from 'app/core/store/template/relocation-templates.resolve';
import { CalendarOrdersPageContainer } from 'app/modules/calendar/orders/calendar-orders-page-container/calendar-orders-page.container';
import { CalendarRelocationsPageContainer } from 'app/modules/calendar/relocations/calendar-relocations-page-container/calendar-relocations-page.container';
import { OrderFilterValuesLoadGuard } from '../../core/guards/order-filter-values-load.guard';

const routes: Routes = [
  {
    path: 'calendar/order',
    component: CalendarOrdersPageContainer,
    canActivate: [DependencyTreeGuard],
    canDeactivate: [CalendarClearStateUnguard],
    data: {
      guards: [OrderFilterValuesLoadGuard, GetOrderTemplatesGuard],
      type: 'ORDER',
    },
  },
  {
    path: 'calendar/relocation',
    component: CalendarRelocationsPageContainer,
    canActivate: [DependencyTreeGuard],
    canDeactivate: [CalendarClearStateUnguard],
    data: {
      guards: [GetRelocationTemplatesGuard],
      type: 'RELOCATION',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CalendarRoutingModule {}
